import { render, staticRenderFns } from "./TheTableDiscounts.vue?vue&type=template&id=c221bc40&scoped=true&"
import script from "./TheTableDiscounts.vue?vue&type=script&lang=ts&"
export * from "./TheTableDiscounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c221bc40",
  null
  
)

export default component.exports